<template>
  <!-- <svg class="svg-icon" style="" aria-hidden="true">
    <use :xlink:href="iconName" />
  </svg> -->
    <span class="jr-icon">
    <i class="sgbIcon" :class="iconTag" :style="{ color: color + ' !important', fontSize: size + 'px !important' }">
      <slot></slot>
    </i>
    <span class="weui-badge" v-if="badge != '' && badge != 0" :style="`position: absolute; top: -2px; right:${leftcount}`">{{badge}}</span>
    </span>
</template>
 
 
<script >
export default {
  name: 'jr-icon',
  data: function () {
    return {
      showbadge: true,
    };
  },
  props: {
    name: {
      type: String,
      default: function () {
        return '';
      },
    },
    size: {
      type: String,
      default: function () {
        return '';
      },
    },
    color: {
      type: String,
      default: function () {
        return '';
      },
    },
    badge: {
      type: String,
      default: function () {
        return '';
      },
    },
    leftcount: {
      type: String,
      default: function () {
        return '-10px';
      },
    },
  },
  computed: {
    iconTag() {
      return `icon${this.name}`;
    }
  },
};
</script>
<style lang="scss" type="text/css" scoped>
$btn_primay:#ff9900;
$btn_default:#999999;
$large_size:45px; //最大图标  快速入口
$big_size:30px; //大图标，底部toolbar
$normal_size:25px;// 普通图标 我的应用
$small_size:19px; // 小图标 标题左边图标

.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.sgbIcon{
  line-height: 1 !important;
  font-size: 19px;
}
.big-icon i {
    font-size: $big_size;
}
.small-icon i{
  font-size:$small_size;
}
.normal-icon i{
    font-size:$normal_size;
  }
.large-icon i {
    font-size: $large_size;
}
.icon-actived i {
    color: $btn_primay;
}
.icon-default i {
    color: $btn_default;
}
.jr-icon{
  display: inline-block; 
  position: relative;
}
.weui-badge {
    display: inline-block;
    padding: .15em .45em;
    min-width: 8px;
    border-radius: 18px;
    background-color: #f43530;
    color: #fff;
    line-height: 1.2;
    text-align: center;
    font-size: 12px;
    vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// src/components/jr-icon/index.vue